// InventoryAdminInventory - Main Dashboard Component
import React from 'react';
import '../../../../assests/css/admin/Analytics/AdminAnalytics.css';
import MetricCard from '../../../../components/Admin/Analytics/MetricCard/MetricCard';
import SalesPerformance from '../../../../components/Admin/Analytics/SalesPerformance/SalesPerformance';
import UserActivity from '../../../../components/Admin/Analytics/UserAcitivity/UserActivity';
import TopProducts from '../../../../components/Admin/Analytics/TopProducts/TopProducts';
import InventoryStatus from '../../../../components/Admin/Analytics/InventoryStatus/InventoryStatus';
import GlobalCashFlow from '../../../../components/Admin/Analytics/GlobalCashFlow/GlobalCashFlow';
import RiskEvolution from '../../../../components/Admin/Analytics/RiskEvolution/RiskEvolution';
import AiFeature from '../../../../components/Admin/Dasboard/AiFeature/AiFeature';

const AdminAnalytics = () => {
  const metrics = [
    {
      icon: '💰',
      label: 'Total Revenue',
      value: '$124,592.00',
      change: '+12.5%',
      changeType: 'positive',
      iconColor: 'purple'
    },
    {
      icon: '🛍️',
      label: 'Total Orders',
      value: '3,842',
      change: '+8.2%',
      changeType: 'positive',
      iconColor: 'pink'
    },
    {
      icon: '📊',
      label: 'Avg. Order Value',
      value: '$32.42',
      change: '+4.3%',
      changeType: 'positive',
      iconColor: 'blue'
    },
    {
      icon: '↩️',
      label: 'Return Rate',
      value: '1.2%',
      change: '-3.1%',
      changeType: 'negative',
      iconColor: 'green'
    }
  ];

  return (
    <div className="InventoryAdminInventory-dashboard">
      {/* Header */}
      <header className="InventoryAdminInventory-header">
        <div className="InventoryAdminInventory-header-top">
          <div>
            <h1 className="InventoryAdminInventory-title">
              <span className="InventoryAdminInventory-title-icon">📈</span>
              Business Analytics
            </h1>
            <p className="InventoryAdminInventory-subtitle">
              Real-time performance metrics and operational insights
            </p>
          </div>
          <div className="InventoryAdminInventory-header-actions">
            <div className="InventoryAdminInventory-date-range">
              <span>📅</span>
              <span>Oct 24, 2023 - Oct 31, 2023</span>
            </div>
           
          </div>
        </div>
      </header>

      {/* Metrics Cards */}
      <div className="InventoryAdminInventory-metrics-grid">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>

      {/* Sales Performance & User Activity */}
      <div className="InventoryAdminInventory-main-grid">
        <SalesPerformance />
        <UserActivity />
      </div>

      {/* Top Products & Inventory Status */}
      <div className="InventoryAdminInventory-products-inventory-grid">
        <TopProducts />
        <InventoryStatus />
      </div>

      {/* Global Cash Flow */}
      <div className="InventoryAdminInventory-footer-section">
        <GlobalCashFlow />
      </div>
      
      

    </div>

    
  );
};

export default AdminAnalytics;